module.exports = __webpack_public_path__ + "static/img/logo.ea7a4c1b.png";